import './style.scss';

export function map_block() {
  const block = document.querySelector('.map_block');
  if (!block) return;
  
}
